<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <!-- Header moderno -->
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Postulaciones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Planta Externa</li>
                  <li class="breadcrumb-item active">Operaciones</li>
                  <li class="breadcrumb-item active">Postulaciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>

        <section class="content">
          <div class="container-fluid" v-if="detProgramacion">
            <!-- Card principal moderna -->
            <div class="card border-0 shadow-lg">
              <!-- Header de la card -->
              <div class="card-header bg-geogo text-white">
                <div class="row align-items-center">
                  <div class="col-lg-8">
                    <h5 class="mb-0 text-white font-weight-bold">
                      <i class="fas fa-building"></i>
                      {{ detProgramacion.empresa?.razon_social ?? "—" }} |
                      <i class="fas fa-calendar-alt me-1"></i>
                      {{ detProgramacion.programacion?.fecha ?? "—" }} |
                      <i class="fas fa-route"></i>
                      {{ detProgramacion.programacion?.sitio?.nombre ?? "—" }}
                    </h5>
                  </div>
                  <div class="col-lg-4 text-end">
                    <div class="d-flex justify-content-end">
                      <button
                        class="btn btn-light btn-lg shadow-sm me-2"
                        @click="saveEstado()"
                        v-if="$store.getters.can('plantaEx.postulaciones.edit')"
                        :disabled="!puedeFinalizar"
                        :title="
                          puedeFinalizar
                            ? 'Finalizar postulaciones'
                            : 'Complete todas las postulaciones para finalizar'
                        "
                      >
                        <i class="fas fa-flag-checkered me-2"></i>
                        Finalizar
                      </button>
                      <button
                        type="button"
                        class="btn btn-outline-light btn-lg shadow-sm"
                        @click="enviarCorreo()"
                        v-if="
                          $store.getters.can(
                            'plantaEx.postulaciones.enviarCorreo',
                          )
                        "
                      >
                        <i class="fas fa-envelope me-2"></i>
                        Enviar Correo
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Barra de progreso mejorada -->
              <div class="bg-light px-4 py-4 mb-3">
                <div class="mb-2">
                  <i class="fas fa-chart-line text-primary me-2"></i>
                  <strong class="text-dark"> Progreso de Postulaciones</strong>
                  <span class="float-right">
                    <h4 class="mb-0 text-primary font-weight-bold d-inline">
                      {{ porcentaje }}%
                    </h4>
                    <small class="text-muted ml-2">Completado</small>
                  </span>
                </div>
                <div class="progress" style="height: 25px; border-radius: 8px">
                  <div
                    class="progress-bar bg-primary progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    :style="'width:' + porcentaje + '%'"
                    :aria-valuenow="porcentaje"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <strong>{{ porcentaje }}%</strong>
                  </div>
                </div>
              </div>

              <div class="card-body p-4">
                <div v-if="tieneDetalles" class="row">
                  <div
                    v-for="grupo in postulacionesAgrupadas"
                    :key="grupo.key"
                    class="col-md-12 mb-4"
                  >
                    <div
                      class="card card-outline collapsed-card border-0 shadow-lg mb-4"
                      :class="claseProgresoGrupo(grupo)"
                    >
                      <div class="card-header bg-geogo-top-left py-2">
                        <div class="row align-items-center">
                          <div class="col-xl col-12 mb-2 mb-xl-0">
                            <div
                              class="d-flex flex-wrap align-items-center gap-2"
                            >
                              <template
                                v-for="(item, idx) in itemsGrupoHeader(grupo)"
                              >
                                <span
                                  v-if="item.tipo === 'sep'"
                                  :key="`sep-${grupo.key}-${idx}`"
                                  class="text-white px-1"
                                  >|</span
                                >
                                <span
                                  v-else-if="item.tipo === 'badge'"
                                  :key="`badge-${grupo.key}-${idx}`"
                                  class="badge px-2 py-1 shadow-sm me-1 mb-1"
                                  :class="item.class"
                                >
                                  {{ item.text }}
                                  <i
                                    v-if="item.icon"
                                    class="fas mx-1"
                                    :class="item.icon"
                                  ></i>
                                  <template v-if="item.suffix">{{
                                    item.suffix
                                  }}</template>
                                </span>
                              </template>
                            </div>
                          </div>

                          <div class="col-xl-auto col-12">
                            <div
                              class="d-flex align-items-center justify-content-xl-end justify-content-between"
                            >
                              <div
                                class="d-flex align-items-center bg-white rounded-pill px-3 py-2 shadow-sm mr-4"
                              >
                                <span
                                  class="badge badge-warning me-2 px-2 py-1"
                                  >{{ resumenCarguesGrupo(grupo).total }}</span
                                >
                                <i class="fas fa-minus text-muted mx-1"></i>
                                <span
                                  class="badge badge-success mx-1 px-2 py-1"
                                  >{{
                                    resumenCarguesGrupo(grupo).completados
                                  }}</span
                                >
                                <i class="fas fa-equals text-muted mx-1"></i>
                                <span class="badge badge-info ms-1 px-2 py-1">{{
                                  resumenCarguesGrupo(grupo).pendientes
                                }}</span>
                              </div>
                              <button
                                type="button"
                                class="btn btn-primary btn-sm ms-2"
                                data-card-widget="collapse"
                              >
                                <i class="fas fa-plus"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card-body p-0">
                        <table
                          class="table table-bordered table-striped table-hover table-sm mb-0"
                        >
                          <thead class="text-center">
                            <tr>
                              <th>#</th>
                              <th
                                v-for="col in columnasPostulacion"
                                :key="col.key"
                                :style="col.width ? { width: col.width } : null"
                              >
                                {{ col.label }}
                              </th>
                            </tr>
                          </thead>
                          <tbody class="text-center">
                            <tr
                              v-for="fila in filasGrupo(grupo)"
                              :key="`${fila.det.id}-${fila.detIndex}`"
                            >
                              <td>{{ fila.numeroFila }}</td>
                              <td class="text-center">
                                <span class="badge badge-info"
                                  >{{ fila.det.nombre_origen }} -{{
                                    fila.det.fecha_cita
                                  }}</span
                                >
                              </td>
                              <td>
                                <span class="badge badge-secondary">{{
                                  fila.det.nombre_equipo
                                }}</span>
                              </td>
                              <td>
                                <input
                                  v-if="estaEditando(fila.detIndex, fila.slot)"
                                  type="text"
                                  class="form-control form-control-sm"
                                  v-model="formActualizar.vehiculo.placa"
                                  @change="
                                    buscarVehiculos(
                                      fila.det.tipo_ruta,
                                      fila.det.tipo_vehiculo_id,
                                      null,
                                    )
                                  "
                                  :class="
                                    $v.formActualizar.vehiculo.id.$invalid
                                      ? 'is-invalid'
                                      : 'is-valid'
                                  "
                                />
                                <span v-else>{{
                                  fila.slot.vehiculo?.placa
                                }}</span>
                              </td>
                              <td>
                                <template v-if="requiereRemolque(fila.det)">
                                  <input
                                    v-if="
                                      estaEditando(fila.detIndex, fila.slot)
                                    "
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="formActualizar.remolque.placa"
                                    @change="buscarRemolques()"
                                    :class="
                                      $v.formActualizar.remolque.id.$invalid
                                        ? 'is-invalid'
                                        : 'is-valid'
                                    "
                                  />
                                  <span v-else>{{
                                    fila.slot.remolque?.placa || ""
                                  }}</span>
                                </template>
                              </td>
                              <td>
                                <template
                                  v-if="estaEditando(fila.detIndex, fila.slot)"
                                >
                                  <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="
                                      formActualizar.conductor.numero_documento
                                    "
                                    @change="buscarConductores()"
                                    :class="
                                      $v.formActualizar.conductor.id.$invalid
                                        ? 'is-invalid'
                                        : 'is-valid'
                                    "
                                  />
                                  {{ formActualizar.conductor.nombres }}
                                  {{ formActualizar.conductor.apellidos }}
                                </template>
                                <span v-else>
                                  {{ fila.slot.conductor?.numero_documento }} -
                                  {{ fila.slot.conductor?.nombres }}
                                  {{ fila.slot.conductor?.apellidos }}
                                </span>
                              </td>
                              <td>
                                <input
                                  v-if="estaEditando(fila.detIndex, fila.slot)"
                                  type="text"
                                  class="form-control form-control-sm"
                                  v-model="formActualizar.orden_cargue"
                                  :class="
                                    $v.formActualizar.orden_cargue.$invalid
                                      ? 'is-invalid'
                                      : 'is-valid'
                                  "
                                />
                                <span v-else>{{ fila.slot.orden_cargue }}</span>
                              </td>
                              <td>
                                <template
                                  v-if="estaEditando(fila.detIndex, fila.slot)"
                                >
                                  <button
                                    v-if="formActualizar.link_orden_cargue"
                                    type="button"
                                    class="btn btn-sm bg-warning"
                                    @click="eliminarFoto()"
                                  >
                                    <i class="fas fa-trash-alt"></i>
                                  </button>
                                  <input
                                    v-else-if="file === null"
                                    type="file"
                                    class="form-control-file"
                                    accept=".pdf,.jpg,.png"
                                    @change="elegirDirectorio($event)"
                                  />
                                  <button
                                    v-else
                                    type="button"
                                    class="btn btn-sm bg-warning"
                                    @click="borrarFotoParcial()"
                                  >
                                    <i class="fas fa-trash-alt"></i>
                                  </button>
                                </template>
                                <template v-else>
                                  <button
                                    v-if="fila.slot.link_orden_cargue"
                                    type="button"
                                    class="btn btn-sm bg-gray-dark"
                                    @click="
                                      getImage(fila.slot.link_orden_cargue)
                                    "
                                  >
                                    <i class="fas fa-image"></i>
                                  </button>
                                  <span v-else>No hay</span>
                                </template>
                              </td>
                              <td>
                                <span
                                  v-if="fila.slot.nEstado"
                                  class="badge"
                                  :class="
                                    fila.slot.estado == 1
                                      ? 'bg-warning'
                                      : fila.slot.estado == 2
                                      ? 'bg-success'
                                      : fila.slot.estado == 3
                                      ? 'bg-danger'
                                      : fila.slot.estado == 4
                                      ? 'bg-success'
                                      : fila.slot.estado == 5
                                      ? 'bg-danger'
                                      : 'bg-secondary'
                                  "
                                  >{{ fila.slot.nEstado }}</span
                                >
                                <span v-else class="badge bg-danger"
                                  >Sin Postular</span
                                >
                              </td>
                              <td class="text-right">
                                <div
                                  v-if="falgValidando"
                                  class="spinner-border text-dark spinner-border-sm"
                                ></div>
                                <div
                                  v-else-if="
                                    estaEditando(fila.detIndex, fila.slot)
                                  "
                                  class="btn-group"
                                >
                                  <!-- <button
                                    type="button"
                                    class="btn btn-sm bg-success"
                                    v-if="
                                      $store.getters.can(
                                        'plantaEx.postulaciones.edit',
                                      ) && !$v.formActualizar.$invalid
                                    "
                                    @click="
                                      arreglarForm(fila.slot, fila.detIndex)
                                    "
                                  >
                                    <i class="fas fa-check-circle"></i>
                                  </button> -->
                                  <button
                                    type="button"
                                    class="btn btn-sm bg-success"
                                    v-if="
                                      $store.getters.can(
                                        'plantaEx.postulaciones.edit',
                                      ) && file !== null
                                    "
                                    @click="
                                      validarYGuardar(
                                        fila.slot,
                                        fila.detIndex,
                                        fila.det.tipo_ruta,
                                        fila.det.tipo_vehiculo_id,
                                      )
                                    "
                                  >
                                    <i class="fas fa-check-circle"></i>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-sm bg-danger"
                                    @click="limpiarForm()"
                                  >
                                    <i class="fas fa-times-circle"></i>
                                  </button>
                                </div>
                                <div v-else class="btn-group">
                                  <button
                                    type="button"
                                    class="btn btn-sm bg-navy"
                                    v-if="puedeEditarFila(fila.det)"
                                    @click="
                                      verFormActualizar(
                                        fila.detIndex,
                                        fila.slot,
                                        fila.det,
                                        fila.det.programacion?.fecha,
                                        contextoSolicitud(fila.det),
                                      )
                                    "
                                  >
                                    <i class="fas fa-edit"></i>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-sm btn-danger"
                                    v-if="
                                      $store.getters.can(
                                        'plantaEx.postulaciones.delete',
                                      ) && fila.slot.id
                                    "
                                    @click="destroy(fila.slot)"
                                  >
                                    <i class="fas fa-trash-alt"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="alert alert-warning mb-0">
                  <h5 class="mb-0">
                    <i class="fas fa-exclamation-triangle me-2"></i>
                    No se encontraron detalles de programación.
                  </h5>
                </div>
              </div>
              <!-- Footer moderno -->
              <div class="card-footer bg-gradient-light border-0">
                <div class="row align-items-center">
                  <div class="col-12 text-end">
                    <div class="d-flex justify-content-end gap-3">
                      <button
                        class="btn btn-outline-secondary btn-lg shadow-sm"
                        @click="back()"
                        style="border-radius: 8px; padding: 12px 24px"
                      >
                        <i class="fas fa-arrow-left me-2"></i>
                        Volver
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "../../../../components/Loading";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "PostulacionForm",
  components: {
    Loading,
  },
  data() {
    return {
      porcentaje: 0,
      cargando: false,
      pendientes: 0,
      detProgramacion: null,
      file: null,
      formActualizar: {
        link_orden_cargue: null,
      },
      idActualizar: null,
      postulaciones: [],
      det_postulaciones: [],
      falgValidando: false,
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
    };
  },
  validations() {
    let rem_id = {};
    if (this.formActualizar.tipo_vehiculo_id == 1) {
      rem_id = {
        id: {
          required,
        },
      };
    } else {
      rem_id = {
        id: {
          required: false,
        },
      };
    }

    return {
      formActualizar: {
        vehiculo: {
          id: {
            required,
          },
        },
        remolque: rem_id,
        conductor: {
          id: {
            required,
          },
        },
        orden_cargue: {
          required,
        },
      },
    };
  },
  computed: {
    tieneDetalles() {
      return this.postulaciones.length > 0;
    },

    puedeFinalizar() {
      return this.tieneDetalles && this.pendientes === 0;
    },

    detPostulacionesMap() {
      return this.det_postulaciones.reduce((mapa, item) => {
        mapa[item.id_det_solicitud] = item.data;
        return mapa;
      }, {});
    },

    columnasPostulacion() {
      return [
        { key: "fecha_cita", label: "Origen - Cita Cargue", width: "12%" },
        { key: "equipo", label: "Equipo", width: "12%" },
        { key: "vehiculo", label: "Vehículo", width: "10%" },
        { key: "remolque", label: "Remolque", width: "10%" },
        { key: "conductor", label: "Conductor", width: "30%" },
        { key: "orden", label: "Orden Cargue", width: "12%" },
        { key: "adjunto", label: "Adjunto", width: "12%" },
        { key: "estado", label: "Estado", width: "10%" },
        { key: "accion", label: "Acción", width: "50px" },
      ];
    },

    postulacionesAgrupadas() {
      const grupos = new Map();
      this.postulaciones.forEach((det) => {
        const key = this.claveGrupoPostulacion(det);
        if (!grupos.has(key)) {
          grupos.set(key, {
            key,
            bloque: this.textoBloque(det),
            area: this.textoArea(det),
            tipo_vehiculo_id: det.tipo_vehiculo_id ?? "",
            tipo_vehiculo: det.tipo_vehiculo?.nombre ?? "",
            producto: this.textoProducto(det),
            detalles: [],
          });
        }
        grupos.get(key).detalles.push(det);
      });
      return Array.from(grupos.values())
        .map((grupo) => ({
          ...grupo,
          fecha: this.valorComunGrupo(
            grupo,
            (d) => d.programacion?.fecha ?? "",
          ),
          fecha_cita: this.valorComunGrupo(grupo, (d) => d.fecha_cita ?? ""),
        }))
        .sort((a, b) => {
          const ordenBloque = this.compararTexto(a.bloque, b.bloque);
          if (ordenBloque !== 0) return ordenBloque;
          const ordenArea = this.compararTexto(a.area, b.area);
          if (ordenArea !== 0) return ordenArea;
          const ordenTipo = this.compararTexto(
            a.tipo_vehiculo,
            b.tipo_vehiculo,
          );
          if (ordenTipo !== 0) return ordenTipo;
          return this.compararTexto(a.producto, b.producto);
        });
    },
  },

  methods: {
    compararTexto(a, b) {
      return String(a ?? "").localeCompare(String(b ?? ""));
    },

    claveGrupoPostulacion(det) {
      const bloque = this.valorBloque(det);
      const area = this.valorArea(det);
      const tipo =
        det.tipo_vehiculo_id ??
        det.tipo_vehiculo?.id ??
        det.tipo_vehiculo?.nombre ??
        "sin-tipo";
      const producto = this.valorProducto(det);
      return `${bloque}|${area}|${tipo}|${producto}`;
    },

    valorBloque(det) {
      if (det.bloque && typeof det.bloque === "object") {
        return det.bloque.id ?? det.bloque.nombre ?? "sin-bloque";
      }
      return det.bloque_id ?? det.bloque ?? "sin-bloque";
    },

    textoBloque(det) {
      if (det.bloque && typeof det.bloque === "object") {
        return (
          det.bloque.nombre ?? det.bloque.descripcion ?? det.bloque.id ?? ""
        );
      }
      return det.bloque_nombre ?? det.bloque ?? "";
    },

    valorArea(det) {
      if (det.area && typeof det.area === "object") {
        return (
          det.area.numeracion ??
          det.area.id ??
          det.area.descripcion ??
          "sin-area"
        );
      }
      return det.area_id ?? det.area ?? "sin-area";
    },

    textoArea(det) {
      if (det.area && typeof det.area === "object") {
        return (
          det.area.descripcion ?? det.area.nombre ?? det.area.numeracion ?? ""
        );
      }
      return det.area_descripcion ?? det.area_nombre ?? det.area ?? "";
    },

    valorProducto(det) {
      const producto = det.tipo_producto ?? det.tipoProducto;
      if (producto && typeof producto === "object") {
        return producto.id ?? producto.nombre ?? "sin-producto";
      }
      return (
        det.tipo_producto_id ??
        det.tipoProducto_id ??
        producto ??
        "sin-producto"
      );
    },

    textoProducto(det) {
      const producto = det.tipo_producto ?? det.tipoProducto;
      if (producto && typeof producto === "object") {
        return producto.nombre ?? producto.descripcion ?? producto.id ?? "";
      }
      return (
        det.tipo_producto_nombre ?? det.tipoProducto_nombre ?? producto ?? ""
      );
    },

    textoCitaGrupo(grupo) {
      const cita = grupo.fecha_cita;
      if (grupo.fecha === "Varios" || cita === "Varios") return "Varios";
      if (!cita) return grupo.fecha || "Sin definir";
      if (/^\d{4}-\d{2}-\d{2}/.test(cita)) return cita;
      return grupo.fecha ? `${grupo.fecha} ${cita}` : cita;
    },

    valorComunGrupo(grupo, obtener) {
      const valores = grupo.detalles
        .map(obtener)
        .filter((v) => v !== null && v !== undefined && v !== "");
      const unicos = [...new Set(valores)];
      if (unicos.length === 1) return unicos[0];
      if (unicos.length > 1) return "Varios";
      return null;
    },

    itemsGrupoHeader(grupo) {
      const items = [];
      this.etiquetasGrupoHeader(grupo).forEach((etiqueta, idx) => {
        if (idx > 0) items.push({ tipo: "sep" });
        items.push({ tipo: "badge", ...etiqueta });
      });
      return items;
    },

    etiquetasGrupoHeader(grupo) {
      const origen = this.valorComunGrupo(
        grupo,
        (d) => d.origen?.nombre ?? d.nombre_origen,
      );
      const destino = this.valorComunGrupo(grupo, (d) => d.destino?.nombre);
      const producto = this.valorComunGrupo(
        grupo,
        (d) => d.tipo_producto?.nombre ?? d.tipoProducto?.nombre,
      );
      const vehiculo = this.valorComunGrupo(
        grupo,
        (d) => d.tipo_vehiculo?.nombre,
      );
      const area = this.valorComunGrupo(grupo, (d) => d.nArea ?? "");

      return [
        {
          class: "badge-info",
          text: `Área: ${area ?? "—"}`,
        },
        {
          class: "badge-success",
          text: `Ruta: ${origen ?? "—"}`,
          icon: "fa-arrow-right",
          suffix: destino ?? "Sin Asignar",
        },
        {
          class: "badge-warning",
          text: `Mercancía: ${producto ?? "—"}`,
        },
        {
          class: "badge-primary",
          text: `Tipo Vehículo: ${vehiculo ?? "—"}`,
        },
      ];
    },

    resumenCarguesGrupo(grupo) {
      return grupo.detalles.reduce(
        (acc, det) => {
          const r = this.resumenCargues(det);
          acc.total += r.total;
          acc.completados += r.completados;
          acc.pendientes += r.pendientes;
          return acc;
        },
        { total: 0, completados: 0, pendientes: 0 },
      );
    },

    claseProgresoGrupo(grupo) {
      const r = this.resumenCarguesGrupo(grupo);
      const pct = r.total ? Math.round((r.completados / r.total) * 100) : 0;
      if (pct >= 100) return "border-left-success";
      if (pct > 40) return "border-left-warning";
      if (pct > 0) return "border-left-secondary";
      return "border-left-danger";
    },

    filasGrupo(grupo) {
      const filas = [];
      let numeroFila = 0;
      grupo.detalles.forEach((det) => {
        const slots = this.slotsDetalle(det.id);
        slots.forEach((slot, detIndex) => {
          numeroFila += 1;
          filas.push({
            det,
            slot,
            detIndex,
            numeroFila,
          });
        });
      });
      return filas;
    },

    slotsDetalle(detId) {
      return this.detPostulacionesMap[detId] || [];
    },

    estaEditando(detIndex, det) {
      return (
        this.idActualizar === detIndex &&
        det.det_plant_programacion_id ===
          this.formActualizar.det_plant_programacion_id
      );
    },

    resumenCargues(det) {
      const total = Number(det.cargues) || 1;
      const completados = this.slotsDetalle(det.id).filter((p) => p?.id).length;
      return {
        total,
        completados,
        pendientes: Math.max(total - completados, 0),
      };
    },

    contextoSolicitud(det) {
      return {
        sitio: det.origen?.nombre || {},
        fecha: det.programacion?.fecha,
      };
    },

    requiereRemolque(det) {
      return Number(det.tipo_vehiculo_id) === 1;
    },

    puedeEditarFila(det) {
      if (!this.$store.getters.can("plantaEx.postulaciones.edit")) {
        return false;
      }
      if (this.$store.getters.can("plantaEx.postulaciones.editSU")) {
        return true;
      }
      const fechaCita = det.fecha_cita
        ? `${det.programacion?.fecha} ${det.fecha_cita}`
        : det.programacion?.fecha;
      return fechaCita ? moment().isBefore(moment(fechaCita)) : false;
    },

    detalleProgramacion(detId) {
      return (
        this.postulaciones.find((p) => p.id === detId) || this.detProgramacion
      );
    },

    borrarFotoParcial() {
      this.file = null;
    },

    getIndex() {
      this.cargando = true;
      axios
        .get("/api/plant/postulaciones/show", {
          params: {
            empresa_id: this.$route.params.empresa_id,
            programacion_id: this.$route.params.programa_id,
          },
        })
        .then(async (response) => {
          this.postulaciones = response.data || [];
          this.detProgramacion = this.postulaciones[0] || null;
          await this.getPostulaciones(this.postulaciones);
          this.barraPorcentaje();
          this.cargando = false;
        })
        .catch(() => {
          this.postulaciones = [];
          this.detProgramacion = null;
          this.cargando = false;
        });
    },

    barraPorcentaje() {
      let contador = 0;
      let carguesTotal = 0;
      this.pendientes = 0;

      this.postulaciones.forEach((det) => {
        const resumen = this.resumenCargues(det);
        contador += resumen.completados;
        carguesTotal += resumen.total;
        this.pendientes += resumen.pendientes;
      });

      this.porcentaje = carguesTotal
        ? Math.round((contador / carguesTotal) * 100)
        : 0;
    },

    postulacionVacia(det) {
      return {
        id: null,
        det_plant_programacion_id: det.id,
        vehiculo: { id: "", placa: "" },
        remolque: { id: "", placa: "" },
        conductor: { id: "", numero_documento: "", nombres: "", apellidos: "" },
        orden_cargue: "",
        tipo_vehiculo_id: det.tipo_vehiculo_id,
        adicional: det.adicional,
      };
    },

    getPostulaciones(detalles = []) {
      this.det_postulaciones = detalles.map((det) => ({
        id_det_solicitud: det.id,
        data: Array.from(
          { length: Number(det.cargues) || 1 },
          (_, i) => det.det_postulaciones?.[i] ?? this.postulacionVacia(det),
        ),
      }));
    },

    // Se valida si está a tiempo de realizar postulaciones
    validarVigencia(det) {
      let vigente = 0;
      const detProg = this.detalleProgramacion(det.det_plant_programacion_id);
      const fechaStr = detProg?.programacion?.fecha;
      if (!fechaStr) {
        if (this.$store.getters.can("plantaEx.postulaciones.editSU")) {
          vigente = 1;
        }
        return vigente;
      }

      const fecha = moment(fechaStr)
        .add(1, "day")
        .startOf("day");
      const hoy = moment().startOf("day");
      const manana = moment()
        .add(1, "day")
        .startOf("day");
      const ahora = moment();

      const sitio = detProg?.origen || {};
      const fecha_hora_cita = detProg?.fecha_cita
        ? `${fechaStr} ${detProg.fecha_cita}`
        : fechaStr;

      if (fecha.isSame(manana, "day")) {
        if (ahora.hour() < 24) {
          vigente = 1;
        } else {
          const resvaltiempo = this.validarTiempo(
            fecha_hora_cita,
            sitio.tiempo_maximo_cambio,
            ahora.toDate(),
          );
          vigente = resvaltiempo ? 1 : 2;
        }
      } else if (fecha.isAfter(manana, "day")) {
        vigente = 1;
      } else if (fecha.isSame(hoy, "day")) {
        const resvaltiempo = this.validarTiempo(
          fecha_hora_cita,
          sitio.tiempo_maximo_cambio,
          ahora.toDate(),
        );
        vigente = resvaltiempo ? 1 : det.adicional == 1 ? 1 : 0;
      }

      if (this.$store.getters.can("plantaEx.postulaciones.editSU")) {
        vigente = 1;
      }
      return vigente;
    },

    // Se valida si está a tiempo de realizar ediciones de postulaciones
    validarTiempo(fecha_hora_cita, tiempo_maximo_cambio, hoy) {
      const ahora = hoy;
      const cita = new Date(fecha_hora_cita);
      let diffMs = cita - ahora;
      let diffMins = Math.round(diffMs / 60000);
      if (diffMins > tiempo_maximo_cambio) {
        return true;
      }
      return false;
    },

    saveEstado() {
      if (!this.puedeFinalizar) {
        this.$swal({
          icon: "warning",
          title: "Aún hay postulaciones pendientes",
          text: "Debe completar todas las programaciones antes de finalizar.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
        return;
      }

      this.$swal({
        title: "Está seguro de terminar estas postulaciones?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Terminar!",
      }).then((result) => {
        if (result.value) {
          this.cargando = true;
          let estado = 2;
          let form = {
            id: this.postulaciones.id,
            estado,
          };
          axios({
            method: "PUT",
            url: "/api/plant/postulaciones/cambiaEstadoDetSolicitudEmp",
            data: form,
          })
            .then(() => {
              this.postulaciones.estado = 2;
              this.$swal({
                icon: "success",
                title: "La postulación se guardó exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              this.cargando = false;
            })
            .catch((e) => {
              this.$swal({
                icon: "error",
                title: "Ocurrió un error, vuelva a intentarlo..." + e,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              this.cargando = false;
            });
        }
      });
    },

    getImage(url) {
      window.open(this.uri_docs + url, "_blank");
    },

    eliminarFoto() {
      this.formActualizar.link_orden_cargue = null;
    },

    async buscarVehiculos(
      tipo_ruta,
      tipo_vehiculo,
      det_plant_programacion_id = null,
    ) {
      this.falgValidando = true;
      let dato = this.formActualizar.vehiculo.placa;
      let res = await this.validarStatus(dato, "V", det_plant_programacion_id);

      if (Object.keys(res).length > 0) {
        // Validaciones combinadas - Solo alertas informativas, no restrictivas
        let mensajeCombinado = "";
        let tieneProblemas = false;

        // Validación de documentación
        if (res.validacion.error) {
          mensajeCombinado +=
            "⚠️ <strong>Advertencia:</strong> El vehículo tiene problemas de documentación<br><br>";

          if (res.validacion.error.documentos !== undefined) {
            if (res.validacion.error.documentos.obligatorios) {
              mensajeCombinado +=
                "📋 <strong>Documentos pendientes:</strong><br>";
              res.validacion.error.documentos.obligatorios.forEach((doc) => {
                mensajeCombinado += `• ${doc}<br>`;
              });
              mensajeCombinado += "<br>";
            }
            if (res.validacion.error.documentos.vencidos) {
              mensajeCombinado +=
                "📅 <strong>Documentos vencidos:</strong><br>";
              res.validacion.error.documentos.vencidos.forEach((doc) => {
                mensajeCombinado += `• ${doc.documento} - Vence: ${doc.fecha_vencimiento}<br>`;
              });
              mensajeCombinado += "<br>";
            }
            if (res.validacion.error.documentos.no_verificados) {
              mensajeCombinado +=
                "❓ <strong>Documentos no verificados:</strong><br>";
              res.validacion.error.documentos.no_verificados.forEach((doc) => {
                mensajeCombinado += `• ${doc}<br>`;
              });
              mensajeCombinado += "<br>";
            }
          } else {
            mensajeCombinado += res.validacion.error.msg;
          }
          tieneProblemas = true;
        }

        // Validación GPS
        if (res.ultimo_registro) {
          const fechaAct = moment().format("YYYY-MM-DD HH:mm:ss");
          const fechaCorte = moment(fechaAct)
            .add(-6, "hours")
            .format("YYYY-MM-DD HH:mm:ss");
          const fechaGps = moment(
            res.ultimo_registro.fecha_hora_ultimo_reporte,
          ).format("YYYY-MM-DD HH:mm:ss");

          if (fechaCorte > fechaGps) {
            if (tieneProblemas) {
              mensajeCombinado += "<br>---<br><br>";
            }
            mensajeCombinado +=
              "⚠️ <strong>Advertencia GPS:</strong> El vehículo no ha reportado GPS en las últimas 6 horas. Se recomienda validar con el proveedor.<br>";
            tieneProblemas = true;
          }
        }

        // Validación de registro satelital y distancia
        if (res.ultimoRegistro) {
          if (res.ultimoRegistro.error) {
            // Verificar el tipo de error
            if (res.ultimoRegistro.error.code === -4) {
              // Error en la petición a Google Maps API - No es problema del vehículo
              // Solo mostrar advertencia si hay otros problemas, no bloquear
              if (tieneProblemas) {
                mensajeCombinado += "<br>---<br><br>";
                mensajeCombinado +=
                  "⚠️ <strong>Nota:</strong> No se pudo validar la distancia al sitio (problema temporal con el servicio de mapas).<br>";
              }
            } else {
              // Otros errores GPS sí son problemas del vehículo
              if (tieneProblemas) {
                mensajeCombinado += "<br>---<br><br>";
              }

              // Mostrar mensaje específico según el tipo de error
              if (res.ultimoRegistro.error.msg) {
                if (
                  res.ultimoRegistro.error.msg.includes(
                    "fuera del rango permitido",
                  )
                ) {
                  mensajeCombinado += `⚠️ <strong>Advertencia GPS:</strong> ${res.ultimoRegistro.error.msg}<br>`;
                  tieneProblemas = true;
                } else if (
                  res.ultimoRegistro.error.msg.includes("No se encontro ruta")
                ) {
                  mensajeCombinado +=
                    "No se encontró ruta para el vehículo, se recomienda validar con el proveedor GPS.<br>";
                } else {
                  mensajeCombinado += `⚠️ <strong>Advertencia GPS:</strong> ${res.ultimoRegistro.error.msg}<br>`;
                  tieneProblemas = true;
                }
              }
            }
          } else if (res.ultimoRegistro.success) {
            // GPS funcionando correctamente - NO es un problema
            // Solo mostrar mensaje informativo si ya hay otros problemas
            if (tieneProblemas) {
              mensajeCombinado += "<br>---<br><br>";
              mensajeCombinado += `✅ <strong>GPS OK:</strong> ${res.ultimoRegistro.success.msg} Distancia: ${res.ultimoRegistro.success.distance} Km<br>`;
            }
            // NO marcar tieneProblemas = true cuando el GPS está OK
          }
        } else {
          if (tieneProblemas) {
            mensajeCombinado += "<br>---<br><br>";
          }
          mensajeCombinado +=
            "⚠️ <strong>Advertencia GPS:</strong> El vehículo no tiene integración GPS activa. Se recomienda validar con el proveedor GPS.<br>";
          tieneProblemas = true;
        }

        // Mostrar alerta combinada si hay problemas
        if (tieneProblemas) {
          mensajeCombinado +=
            "<br><em>Se recomienda resolver estos problemas, para continuar con la postulación.</em>";

          await this.$swal({
            html: mensajeCombinado,
            icon: "warning",
            confirmButtonText: "Continuar",
            showCancelButton: false,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }

        /* if (res.viaje) {
          this.$swal({
            icon: "error",
            title: `El vehículo se encuentra activo dentro de un viaje`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }

        if (res.postulacion) {
          this.$swal({
            icon: "error",
            title: `El vehículo ya cuenta con una postulacion activa.`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 6000,
            timerProgressBar: true,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        } */

        if (res.info == false) {
          this.$swal({
            icon: "error",
            title: `Hacen falta campos por diligenciar en el formulario de creacion de Vehiculos`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }

        if (!res.has_lineas) {
          this.$swal({
            icon: "error",
            title: `El vehiculo no se encuentra en la linea de negocio Planta Externa`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }

        //Valida el tipo de vehiculo
        if (res.tipo_vehiculo_id != tipo_vehiculo) {
          this.$swal({
            icon: "error",
            title: `El tipo de vehículo no coincide.`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.vehiculo = {};
          this.falgValidando = false;
          return false;
        }

        //Validar si el vehiculo tiene mas de 15 años en operacion
        let dato = res.placa;
        let antiguedad = moment().diff(moment(res.fecha_matricula), "years");

        if (res.fecha_matricula_vencida) {
          let msg =
            "⚠️ <strong>Advertencia:</strong> El vehiculo con placa " +
            dato +
            "<br> tiene " +
            antiguedad +
            " años y no esta permitido (Maximo 15 años). <br><br>";
          await this.$swal({
            html: msg,
            icon: "warning",
            confirmButtonText: "Continuar",
            showCancelButton: false,
          });
          this.falgValidando = false;
          this.formActualizar.vehiculo = {};
          return false;
        }

        // Asignar vehículo y continuar
        this.formActualizar.vehiculo = res;
        this.falgValidando = false;
        return true;
      } else {
        this.$swal({
          icon: "error",
          title:
            "El vehículo digitado NO se encuentra registrado, pruebe con otra placa.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });

        this.falgValidando = false;
        this.formActualizar.vehiculo = {};
        return false;
      }
    },

    async buscarRemolques(det_plant_programacion_id = null) {
      this.falgValidando = true;
      let dato = this.formActualizar.remolque
        ? this.formActualizar.remolque.placa
        : null;
      let res = await this.validarStatus(dato, "R", det_plant_programacion_id);
      if (Object.keys(res).length > 0) {
        // Validación de documentación - Solo alertas informativas, no restrictivas
        if (res.validacion.error) {
          let mensajeDoc =
            "⚠️ <strong>Advertencia:</strong> El remolque tiene problemas de documentación<br><br>";

          if (res.validacion.error.documentos !== undefined) {
            if (res.validacion.error.documentos.obligatorios) {
              mensajeDoc += "📋 <strong>Documentos pendientes:</strong><br>";
              res.validacion.error.documentos.obligatorios.forEach((doc) => {
                mensajeDoc += `• ${doc}<br>`;
              });
              mensajeDoc += "<br>";
            }
            if (res.validacion.error.documentos.vencidos) {
              mensajeDoc += "📅 <strong>Documentos vencidos:</strong><br>";
              res.validacion.error.documentos.vencidos.forEach((doc) => {
                mensajeDoc += `• ${doc.documento} - Vence: ${doc.fecha_vencimiento}<br>`;
              });
              mensajeDoc += "<br>";
            }
            if (res.validacion.error.documentos.no_verificados) {
              mensajeDoc +=
                "❓ <strong>Documentos no verificados:</strong><br>";
              res.validacion.error.documentos.no_verificados.forEach((doc) => {
                mensajeDoc += `• ${doc}<br>`;
              });
              mensajeDoc += "<br>";
            }
          } else {
            mensajeDoc += res.validacion.error.msg;
          }

          mensajeDoc +=
            "<br><em>Se recomienda actualizar la documentación, para continuar con la postulación.</em>";

          this.$swal({
            html: mensajeDoc,
            icon: "warning",
            confirmButtonText: "Continuar",
            showCancelButton: false,
          });
          this.formActualizar.remolque = {};
          this.falgValidando = false;
          return false;
        }

        if (res.info == false) {
          this.$swal({
            icon: "error",
            title: `Hacen falta campos por diligenciar en el formulario de creacion de Relmoques`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.remolque = {};
          this.falgValidando = false;
          return false;
        }

        if (!res.has_lineas) {
          this.$swal({
            icon: "error",
            title: `El Remolque no se encuentra en la linea de negocio Planta Externa`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.remolque = {};
          this.falgValidando = false;
          return false;
        }

        /* if (res.viaje) {
          this.$swal({
            icon: "error",
            title: `El remolque se encuentra activo dentro de un viaje`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.remolque = {};
          this.falgValidando = false;
          return false;
        }

        if (res.postulacion) {
          this.$swal({
            icon: "error",
            title: `El remolque cuenta con una postulacion activa`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.remolque = {};
          this.falgValidando = false;
          return false;
        } */

        //Validar si el Remolque tiene mas de 15 años en operacion
        let dato = res.placa;
        let antiguedad = moment().diff(moment(res.fecha_matricula), "years");

        if (res.fecha_matricula_vencida) {
          let msg =
            "⚠️ <strong>Advertencia:</strong> El Remolque con placa " +
            dato +
            "<br> tiene " +
            antiguedad +
            " años y no esta permitido (Maximo 15 años). <br><br>";
          await this.$swal({
            html: msg,
            icon: "warning",
            confirmButtonText: "Continuar",
            showCancelButton: false,
          });
          this.falgValidando = false;
          this.formActualizar.remolque = {};
          return false;
        }
      } else {
        this.$swal({
          icon: "error",
          title:
            "El remolque digitado NO se encuentra registrado, pruebe con otra placa.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
        this.formActualizar.remolque = {};
        this.falgValidando = false;
        return false;
      }
      // Asignar vehículo y continuar
      this.formActualizar.remolque = res;
      this.falgValidando = false;
    },

    async buscarConductores(det_plant_programacion_id = null) {
      this.falgValidando = true;
      let dato = this.formActualizar.conductor.numero_documento;
      let res = await this.validarStatus(dato, "C", det_plant_programacion_id);

      if (Object.keys(res).length > 0) {
        // Validación de documentación - Solo alertas informativas, no restrictivas
        if (res.validacion.error) {
          let mensajeDoc =
            "⚠️ <strong>Advertencia:</strong> El conductor tiene problemas de documentación<br><br>";

          if (res.validacion.error.documentos !== undefined) {
            if (res.validacion.error.documentos.obligatorios) {
              mensajeDoc += "📋 <strong>Documentos pendientes:</strong><br>";
              res.validacion.error.documentos.obligatorios.forEach((doc) => {
                mensajeDoc += `• ${doc}<br>`;
              });
              mensajeDoc += "<br>";
            }
            if (res.validacion.error.documentos.vencidos) {
              mensajeDoc += "📅 <strong>Documentos vencidos:</strong><br>";
              res.validacion.error.documentos.vencidos.forEach((doc) => {
                mensajeDoc += `• ${doc.documento} - Vence: ${doc.fecha_vencimiento}<br>`;
              });
              mensajeDoc += "<br>";
            }
            if (res.validacion.error.documentos.no_verificados) {
              mensajeDoc +=
                "❓ <strong>Documentos no verificados:</strong><br>";
              res.validacion.error.documentos.no_verificados.forEach((doc) => {
                mensajeDoc += `• ${doc}<br>`;
              });
              mensajeDoc += "<br>";
            }
          } else {
            mensajeDoc += res.validacion.error.msg;
          }

          mensajeDoc +=
            "<br><em>Se recomienda actualizar la documentación, pero puede continuar con la postulación.</em>";

          this.$swal({
            html: mensajeDoc,
            icon: "warning",
            confirmButtonText: "Continuar",
            showCancelButton: false,
          });
          this.formActualizar.conductor = {};
          this.falgValidando = false;
          return false;
        }

        if (res.info == false) {
          this.$swal({
            icon: "error",
            title: `Hacen falta campos por diligenciar en el formulario de creacion de Conductores`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.conductor = {};
          this.falgValidando = false;
          return false;
        }

        if (!res.has_lineas) {
          this.$swal({
            icon: "error",
            title: `El Conductor no se encuentra en la linea de negocio Planta Externa`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          this.formActualizar.conductor = {};
          this.falgValidando = false;
          return false;
        }

        /* if (res.viaje) {
          if (
            this.formActualizar.estado != 1 &&
            this.formActualizar.estado != 2
          ) {
            this.$swal({
              icon: "error",
              title: `El conductor se encuentra activo dentro de un viaje`,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            this.formActualizar.conductor = {};
            this.falgValidando = false;
            return false;
          }
        }

        //Valida si se encuentra con una postulación activa
        if (res.postulacion) {
          if (
            this.formActualizar.estado != 1 &&
            this.formActualizar.estado != 2
          ) {
            this.$swal({
              icon: "error",
              title: `El conductor cuenta con una postulacion activa`,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
            this.formActualizar.conductor = {};
            this.falgValidando = false;
            return false;
          }
        } */

        this.formActualizar.conductor = res;
        this.falgValidando = false;
      } else {
        this.$swal({
          icon: "error",
          title:
            "El conductor digitado NO se encuentra registrado, pruebe con otro documento.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
        this.formActualizar.conductor = {};
        this.falgValidando = false;
        return false;
      }
      this.falgValidando = false;
    },

    async validarYGuardar(det, index, tipo_ruta, tipo_vehiculo) {
      this.falgValidando = true;
      let errores = [];
      await this.buscarVehiculos(
        tipo_ruta,
        tipo_vehiculo,
        det.det_plant_programacion_id,
      );

      await this.buscarConductores(det.det_plant_programacion_id);
      if (!this.formActualizar.vehiculo?.placa) {
        errores.push("Debe seleccionar un vehículo válido.");
      }

      if (!this.formActualizar.conductor?.numero_documento) {
        errores.push("Debe seleccionar un conductor válido.");
      }

      if (errores.length > 0) {
        this.$swal({
          icon: "error",
          title: "Errores en la validación",
          html: `<ul style="text-align: left;">${errores
            .map((err) => `<li>${err}</li>`)
            .join("")}</ul>`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });

        this.falgValidando = false;
        return;
      }
      this.arreglarForm(det, index);
    },

    async validarStatus(dato, tipo, det_plant_programacion_id = null) {
      let me = this;
      let url = "";
      let entidad = null;
      if (tipo == "C") {
        entidad = "Conductor";
        url = "api/plant/postulaciones/validaConductor";
      } else if (tipo == "R") {
        entidad = "Remolque";
        url = "api/plant/postulaciones/validaRemolque";
      } else if (tipo == "V") {
        entidad = "Vehiculo";
        url = "api/plant/postulaciones/validaVehiculo";
      }

      let params = {
        entidad,
        dato,
        fecha: this.detProgramacion?.programacion?.fecha,
        sitio_id: this.detProgramacion?.origen?.id,
        tipo_distancia: 1,
        det_plant_programacion_id,
      };

      var res = null;
      await axios
        .get(url, {
          params,
        })
        .then((response) => {
          res = response.data;
        })
        .catch(function(e) {
          me.$swal({
            icon: "error",
            title: "Ocurrió un error - " + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
      return res;
    },

    back() {
      const toIndex = () =>
        this.$router.replace({ name: "/plantaExterna/Postulaciones" });
      if (this.pendientes != 0) {
        this.$swal({
          title: "Aún no ha realizado todas las postulaciones!",
          text: "¿Está seguro que desea volver?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si, volver!",
        }).then((result) => {
          if (result.value) {
            return toIndex();
          }
        });
      } else {
        return toIndex();
      }
    },

    limpiarForm() {
      this.idActualizar = null;
      this.formActualizar = null;
      this.file = null;
    },

    /**
     * El API puede enviar remolque: null; el template usa formActualizar.remolque.placa.
     * Se reemplaza por un objeto vacío para permitir diligenciar y buscar remolque.
     */
    normalizarFormActualizarDesdeDet(det) {
      const form = { ...det };
      if (form.remolque == null || typeof form.remolque !== "object") {
        form.remolque = { id: null, placa: "" };
      } else {
        form.remolque = {
          ...form.remolque,
          id: form.remolque.id != null ? form.remolque.id : null,
          placa:
            form.remolque.placa != null && form.remolque.placa !== undefined
              ? String(form.remolque.placa)
              : "",
        };
      }
      return form;
    },

    async verFormActualizar(
      id,
      det,
      postulacion,
      fecha_solicitud,
      solicitud_diaria,
    ) {
      if (!this.$store.getters.can("plantaEx.postulaciones.editSU")) {
        const horaCita = postulacion.fecha_cita || "";
        let fechaPlena = new Date(`${fecha_solicitud} ${horaCita}`);
        const tiempoMaximoArriboEnHoras = Number(
          solicitud_diaria.origen?.tiempo_maximo_arribo ?? 0,
        );
        fechaPlena.setHours(fechaPlena.getHours() - tiempoMaximoArriboEnHoras);
        if (fechaPlena < new Date()) {
          this.$swal({
            icon: "error",
            title: `Solo se puede modificar la postulación ${tiempoMaximoArriboEnHoras} horas antes de la hora de la cita`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          return;
        }
      }

      det.adicional = postulacion.adicional;
      this.file = null;
      let resvig = await this.validarVigencia(det);

      if (resvig == 2 && det.id !== null) {
        this.idActualizar = id;
        this.formActualizar = this.normalizarFormActualizarDesdeDet({
          ...det,
        });
      } else if (resvig == 1) {
        this.idActualizar = id;
        this.formActualizar = this.normalizarFormActualizarDesdeDet({
          ...det,
        });
      } else {
        this.$swal({
          icon: "error",
          title: "No puede agregar ni modificar la postulación",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      }
    },

    async arreglarForm(det, index) {
      this.falgValidando = true;

      let form = {
        id: det.id,
        det_plant_programacion_id: det.det_plant_programacion_id,
        vehiculo_id: this.formActualizar.vehiculo.id,
        conductor_id: this.formActualizar.conductor.id,
        estado: 1,
        orden_cargue: this.formActualizar.orden_cargue,
        link_orden_cargue: this.formActualizar.link_orden_cargue,
        fecha_programacion: this.detProgramacion?.programacion?.fecha ?? "",
      };

      let resSave = await this.save(form);

      if (resSave !== null) {
        this.formActualizar.id = resSave.id;
        this.formActualizar.link_orden_cargue = resSave.link_orden_cargue;
        const bucket = this.det_postulaciones.find(
          (post) => post.id_det_solicitud === det.det_plant_programacion_id,
        );
        if (bucket) {
          bucket.data[index] = { ...this.formActualizar };
        }
        this.barraPorcentaje();
        await this.limpiarForm();
      }

      this.falgValidando = false;
    },

    async save(form) {
      let formData = new FormData();
      formData.append("id", form.id);
      formData.append(
        "det_plant_programacion_id",
        form.det_plant_programacion_id,
      );
      formData.append("vehiculo_id", this.formActualizar.vehiculo.id);
      formData.append(
        "remolque_id",
        this.formActualizar.remolque ? this.formActualizar.remolque.id : null,
      );
      formData.append("conductor_id", this.formActualizar.conductor.id);
      formData.append("estado", 1);
      formData.append("orden_cargue", this.formActualizar.orden_cargue);
      formData.append("fecha_programacion", form.fecha_programacion);
      formData.append("link_orden_cargue", this.file);
      var res = false;
      await axios
        .post("api/plant/postulaciones", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(async (response) => {
          if (response.data.error !== undefined) {
            this.$swal({
              icon: "error",
              title: response.data.error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            res = null;
          } else {
            await this.barraPorcentaje();
            res = response.data;
            this.$swal({
              icon: "success",
              title: "La postulación se guardó exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((e) => {
          res = form;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error, vuelva a intentarlo..." + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
      return res;
    },

    async destroy(det) {
      let resvig = await this.validarVigencia(det);
      let status = false;
      if (resvig == 2 && det.id !== null) {
        status = true;
      } else if (resvig == 1) {
        status = true;
      } else {
        this.$swal({
          icon: "error",
          title: "No puede agregar ni modificar la postulación",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      }

      if (status) {
        this.$swal({
          title: "Está seguro de eliminar esta postulación?",
          text: "Los cambios no se pueden revertir!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si, Eliminar!",
        }).then((result) => {
          if (result.value) {
            axios.delete("/api/plant/postulaciones/" + det.id).then(() => {
              this.getIndex();
              this.$swal({
                icon: "success",
                title: "Se eliminó la postulación exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
              });
            });
          }
        });
      }
    },

    elegirDirectorio(event) {
      this.file = event?.target?.files?.[0] ?? null;
    },

    enviarCorreo() {
      this.cargando = true;
      axios
        .get("/api/plant/postulaciones/enviarCorreo", {
          params: {
            plant_programacion_id: this.detProgramacion?.plant_programacion_id,
            empresa_id: this.detProgramacion?.empresa_id,
          },
        })
        .then((response) => {
          this.cargando = false;
          if (response.data.error !== undefined) {
            this.$swal({
              icon: "error",
              title: response.data.error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          } else {
            this.$swal({
              icon: "success",
              title: "Correo enviado satisfactoriamente",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((e) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Error, en el envio de correo:" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
      this.cargando = false;
    },
  },

  beforeMount() {
    this.getIndex();
  },
};
</script>
